export default "__VITE_ASSET__BfDvGYH2__"